module.exports = __webpack_public_path__ + "static/img/stoneCarving_share.b3bd01b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/child/stoneCarving_share.jpg
// module id = 2eGT
// module chunks = 26